import React from "react";
import {CustomNoOptionsMessage} from "../../form-components/CustomNoOptionsMessage";
import {CustomOption} from "../../form-components/CustomOption";
import {CustomSingleValue} from "../../form-components/CustomSingleValue";
import {useTranslation} from "react-i18next";
import {CustomSelect} from "../../form-components/CustomSelect";
import {menuPickerSelect} from "../../../../../selectStyles";

export const MenuPicker = ({menuOptions, setSelectedMenu, dialogRef, addMenu}) => {
    const {t} = useTranslation();

    return (
        <div className={'overlay'}>
            <div className={'form-dialog'} style={{padding: '2rem'}} ref={dialogRef}>
                <div className={'variant-form-dialog-content'}>
                    <div className={'form-dialog-title'} style={{marginBottom: '15px'}}>{t('planMenu')}</div>
                    <CustomSelect id={'menus'}
                                  name={'menus'}
                                  value={{value: 'choose', label: t('choose')}}
                                  onChange={(selected) => {
                                      setSelectedMenu(selected);
                                      addMenu(selected);
                                  }}
                                  styles={menuPickerSelect}
                                  isClearable={false}
                                  isSearchable={false}
                                  iconOnly={true}
                                  options={menuOptions}
                                  components={{
                                      NoOptionsMessage: CustomNoOptionsMessage,
                                      Option: CustomOption,
                                      SingleValue: CustomSingleValue,
                                  }}
                    />
                </div>
            </div>
        </div>
    );
}